module.exports = __webpack_public_path__ + "static/media/1-audio.44771a7.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/1-audio.wav
// module id = Tx3H
// module chunks = 1